import { FC, memo, ReactNode } from "react";
import { TextProps, View, ViewProps } from "@src/components";
import { Text } from "@src/components";

type SectionProps = {
  title: string;
  children: ReactNode;
  titleTextVariant?: TextProps["textStyle"];
  titleColor?: TextProps["color"];
  subtitle?: string;
  style?: ViewProps["style"];
};

export const Section: FC<SectionProps> = memo(
  ({ title, children, titleTextVariant = "sm/regular", titleColor = "text", subtitle, style }) => {
    return (
      <View style={style}>
        <View mb="2xl">
          <Text textStyle={titleTextVariant} color={titleColor}>
            {title}
          </Text>
          {subtitle && (
            <Text textStyle="xs/regular" color="textMuted">
              {subtitle}
            </Text>
          )}
        </View>
        {children}
      </View>
    );
  },
);
